import React, { useState } from 'react';
import PublicNav from "../components/PublicNav";
import Footer from "../components/Footer";
import { requestVerificationCode, submitCertificateRequest } from "../utils/certificates";

const Certificate = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [fullName, setFullName] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleVerifyEmail = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");

    const result = await requestVerificationCode(email);
    setLoading(false);

    if (result.success) {
      setMessage(result.message);
      setStep(2);
    } else {
      setError(result.message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate English Name
    const englishNameRegex = /^[A-Za-z\s]+$/;
    if (!englishNameRegex.test(fullName)) {
      setError("الرجاء كتابة الاسم باللغة الإنجليزية فقط");
      return;
    }

    setLoading(true);
    setError("");
    setMessage("");

    const result = await submitCertificateRequest(email, code, fullName);
    setLoading(false);

    if (result.success) {
      setSubmitted(true);
      setMessage(result.message);
    } else {
      setError(result.message);
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-[#05339c]">
        <PublicNav />
        <div className="flex justify-center items-center min-h-[80vh] p-6">
          <div className="bg-dark-blue rounded-2xl shadow-2xl p-12 border-2 border-green-500 max-w-md w-full text-center">
            <div className="mb-6 flex justify-center">
              <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center border-4 border-green-500">
                <svg
                  className="w-12 h-12 text-green-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={3}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
            </div>
            <h2 className="text-3xl font-bold text-green-400 mb-4">
              تم إرسال الطلب بنجاح!
            </h2>
            <p className="text-white text-lg">{message}</p>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#05339c]">
      <PublicNav />
      <div className="max-w-2xl mx-auto p-6 py-32">
        <div className="bg-dark-blue rounded-2xl shadow-2xl p-8 border-2 border-yellow">
          <h1 className="text-3xl font-semibold text-center mb-8 text-white">
            الحصول على <span className="text-yellow">شهادة المشاركة</span>
          </h1>

          {error && (
            <div className="mb-6 p-4 rounded-lg bg-red-500/20 border-2 border-red-500 text-red-400 text-center font-bold">
              {error}
            </div>
          )}

          {message && !error && (
             <div className="mb-6 p-4 rounded-lg bg-green-500/20 border-2 border-green-500 text-green-400 text-center font-bold">
              {message}
            </div>
          )}

          {step === 1 ? (
            <form onSubmit={handleVerifyEmail} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-yellow mb-2">
                  البريد الإلكتروني المسجل *
                </label>
                <input
                  dir="ltr"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full px-3 py-2 bg-blue/20 border border-yellow rounded-md focus:outline-none focus:ring-2 focus:ring-yellow text-white placeholder-gray-400"
                  placeholder="name@example.com"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-yellow text-dark-blue py-3 px-4 rounded-md hover:bg-yellow/80 focus:outline-none focus:ring-2 focus:ring-yellow disabled:opacity-50 transition-all duration-300 font-bold shadow-lg"
              >
                {loading ? "جاري التحقق..." : "إرسال رمز التحقق"}
              </button>
            </form>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="bg-yellow/10 border border-yellow rounded-lg p-4 mb-6">
                 <p className="text-yellow text-sm text-center">
                   ⚠️ تنبيه: هذه العملية متاحة لمرة واحدة فقط. يرجى التأكد من كتابة الاسم بشكل صحيح كما تريده أن يظهر في الشهادة.
                 </p>
              </div>

              <div>
                <label className="block text-sm font-medium text-yellow mb-2">
                   رمز التحقق *
                </label>
                <input
                  dir="ltr"
                  type="text"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  required
                  className="w-full px-3 py-2 bg-blue/20 border border-yellow rounded-md focus:outline-none focus:ring-2 focus:ring-yellow text-white placeholder-gray-400 text-center tracking-[0.5em] text-lg"
                  placeholder="******"
                  maxLength={6}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-yellow mb-2">
                  الاسم باللغة الإنجليزية (كما سيظهر في الشهادة) *
                </label>
                <input
                  dir="ltr"
                  type="text"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  required
                  className="w-full px-3 py-2 bg-blue/20 border border-yellow rounded-md focus:outline-none focus:ring-2 focus:ring-yellow text-white placeholder-gray-400"
                  placeholder="Full Name in English"
                />
                <p className="text-xs text-white/60 mt-1">يجب كتابة الاسم باللغة الإنجليزية فقط.</p>
              </div>

              <div className="flex gap-3">
                  <button
                    type="button"
                    onClick={() => {
                        setStep(1);
                        setError("");
                        setMessage("");
                    }}
                    className="flex-1 bg-transparent border-2 border-yellow text-yellow py-3 px-4 rounded-md hover:bg-yellow/10 focus:outline-none transition-all duration-300 font-bold"
                  >
                    رجوع
                  </button>
                  <button
                    type="submit"
                    disabled={loading}
                    className="flex-[2] bg-yellow text-dark-blue py-3 px-4 rounded-md hover:bg-yellow/80 focus:outline-none focus:ring-2 focus:ring-yellow disabled:opacity-50 transition-all duration-300 font-bold shadow-lg"
                  >
                    {loading ? "جاري الإرسال..." : "إرسال الطلب"}
                  </button>
              </div>
            </form>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Certificate;
